'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 300px;
  max-width: 500px;
  min-height: 100px;
  background-color: ${colors.secondary.lightGray1};
  padding: 10px;
`;

export const CodeSection = styled.div<{ $copied: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  .copy-indicator {
    color: ${({ $copied }) => ($copied ? colors.semantic.positive.primary : 'inherit')};
  }
  .hint {
    padding-left: 5px;
    font-size: 12px;
  }
`;
